import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';

export default function ModalConfirmarExclusao(props) {
    return (
        <div className="modal-fundo">
            <div className="modal2">
                <div className="modal-titulo">
                    <FiAlertCircle size={88} />
                    <p>ATENÇÃO!</p>
                </div>
                <div className="modal-conteudo">
                    <p>
                        A exclusão não é reversível e propostas em nome do usuário, caso existam, também serão permanentemente excluídas. 
                    </p>
                    <br/>
                    <p>
                        Deseja proseguir com essa ação?
                    </p>
                    <br/>
                    <br/>
                </div>
                <div className="modal-acao">
                    <button className="modal-botao" onClick={(e) => props.setModalConfirmarExclusaoAberto(false)}>
                        Cancelar
                    </button>
                    <button className="modal-botao" onClick={(e) => {props.excluir_cliente(props.clienteIntencaoExcluir); props.setModalConfirmarExclusaoAberto(false);}}>
                        Proseguir
                    </button>
                </div>
            </div>
        </div>
    );
}